import { useQuery } from "@apollo/client";
import { gql } from "generated-graphql";
import { useParams } from "react-router-dom";

import "./useReportDetails";

export const GET_FACILITY_DETAILS = gql(`
  query GetFacilityDetails($id: ID!, $search: String!) {
    facility(id: $id) {
      ...FacilityReportDetailsFragment
      tenant {
        id
        name
        contacts {
          id
          type
          firstName
          lastName
          email
          user {
            person {
              first
              last
            }
          }
        }
      }
    }
    tierIIReports(search: $search) {
      items {
        id
        facilityId
      }
    }
  }
`);

export function useFacilityDetails() {
  const { facilityId, reportingYear } = useParams<{
    facilityId: string;
    reportingYear: string;
  }>();

  const { data, loading, error } = useQuery(GET_FACILITY_DETAILS, {
    variables: {
      id: facilityId ?? "",
      search: `facilityId:${facilityId} reportingYear:${reportingYear} reportKind:ANNUAL`,
    },
    skip: !facilityId || !reportingYear,
  });

  if (error) throw error;

  return { data, loading };
}
